export default __webpack_public_path__ + "35f99c12a40970b6ff49bc5fd66ee553.svg";